export default __webpack_public_path__ + "static/media/small-rupee-copy.f1f0ddea.svg";